<div>
  <label *ngIf="label">{{label}}</label>
  <p-editor #editor [(ngModel)]="value" (onTextChange)="modelChange()" [style]="style" [readonly]="readonly" [placeholder]="placeholder">
    <p-header>
      <select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <select class="ql-color">
        <option value="black"></option>
        <option value="gray"></option>
        <option value="white"></option>
        <option value="red"></option>
        <option value="orange"></option>
        <option value="green"></option>
        <option value="blue"></option>
        <option value="purple"></option>
        <option value="yellow"></option>
      </select>
      <select class="ql-background">
        <option value="black"></option>
        <option value="gray"></option>
        <option value="white"></option>
        <option value="red"></option>
        <option value="orange"></option>
        <option value="green"></option>
        <option value="blue"></option>
        <option value="purple"></option>
        <option value="yellow"></option>
      </select>
      <button class="ql-list" value="bullet"></button>
      <button class="ql-list" value="ordered"></button>
      <button class="ql-indent" value="+1"></button>
      <button class="ql-indent" value="-1"></button>
      <select class="ql-align">
        <option selected></option>
        <option value="right"></option>
        <option value="center"></option>
        <option value="justify"></option>
      </select>
      <button class="ql-script" value="sub"></button>
      <button class="ql-script" value="super"></button>
    </p-header>
  </p-editor>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbb.html